import { Flex } from '@chakra-ui/react';
import { Button, Heading, Paragraph } from 'ui-components';

import { LIST_MAX_HEIGHT } from '../SavedListsModal.constants';

interface EmptyResultsProps {
  height?: number;
  onQueryReset: () => void;
  query: string;
}

export const EmptyResults: React.FC<EmptyResultsProps> = ({
  height,
  onQueryReset,
  query,
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="flex-start"
      direction="column"
      height={height ?? LIST_MAX_HEIGHT}
      paddingTop={12}
    >
      <Flex alignItems="center" direction="column" gap={4} textAlign="center">
        <Heading
          color="primary.300"
          size="md"
          sx={{
            b: {
              color: 'primary.900',
              fontWeight: 'medium',
            },
          }}
        >
          Sorry we could not find any matches for <b>{query}</b>
        </Heading>
        <Paragraph size="md">Please try search with another keyword.</Paragraph>
        <Button variant="tertiary" onClick={onQueryReset}>
          Reset search
        </Button>
      </Flex>
    </Flex>
  );
};
